import Video from "../modules/video";

class Single {

    constructor(root) {
        this.container = root;
        this.videos = [];

        this.container.querySelectorAll('.video-container').forEach(n => this.initVideo(n, this));
    }

    initVideo(node, instance) {
        instance.videos.push(new Video(node));
    }
}

export { Single }